interface PageHeroProps {
  title: string
  subtitle?: string
}

export default function PageHero({ title, subtitle }: PageHeroProps) {
  return (
    <section
      className="pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden"
      style={{ backgroundColor: "#0E8EA0" }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-32 -right-32 w-96 h-96 rounded-full opacity-15"
          style={{ backgroundColor: "#6CC4C4" }}
        />
        <div
          className="absolute bottom-0 -left-20 w-72 h-72 rounded-full opacity-10"
          style={{ backgroundColor: "#B038B2" }}
        />
      </div>
      <div className="relative z-10 max-w-5xl mx-auto px-5 text-center">
        <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4 animate-fade-in-up">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed animate-fade-in-up animation-delay-200">
            {subtitle}
          </p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 30L60 28C120 26 240 22 360 20C480 18 600 18 720 22C840 26 960 34 1080 36C1200 38 1320 34 1380 32L1440 30V60H0V30Z" fill="white"/>
        </svg>
      </div>
    </section>
  )
}
